import { combineReducers } from 'redux';

import alteraPrefeiturasServicosCanais from './alteraPrefeiturasServicosCanais/reducer';
import consultaPrefeiturasServicosCanais from './consultaPrefeiturasServicosCanais/reducer';

export default combineReducers({
	alteraPrefeiturasServicosCanais,
	consultaPrefeiturasServicosCanais,
});
